export default "__VITE_ASSET__BEw57j2P__"